import { ReactNode } from "react";
import { Spinner } from "../../../ui";
import "./tool-card.scss";

interface IToolCardProps {
  title: string;
  icon?: ReactNode;
  children: any;
  footerComponent?: ReactNode;
  statusComponent?: ReactNode;
  iconColor?: "blue";
  isLoading?: boolean;
  isSoon?: boolean;
}

const baseClassName = "tool-card";

export const ToolCard = ({
  icon,
  title,
  children,
  footerComponent,
  statusComponent,
  iconColor,
  isLoading = false,
  isSoon = false,
}: IToolCardProps): JSX.Element => {
  return (
    <div className={`${baseClassName}${isSoon ? ` ${baseClassName}--soon` : ""}`}>
      {isLoading && <Spinner />}
      <div className={`${baseClassName}__body`}>
        <div className={`${baseClassName}__top`}>
          {icon && <span className={`${baseClassName}__icon${iconColor ? ` ${baseClassName}__icon--${iconColor}` : ""}`}>{icon}</span>}
          <span className={`${baseClassName}__title`}>{title}</span>
          {isSoon && (
            <span className={`${baseClassName}__badge`}>Soon</span>
          )}
        </div>
        <div className={`${baseClassName}__desc`}>{children}</div>
        {(footerComponent || statusComponent) && (
          <div className={`${baseClassName}__footer`}>
            {statusComponent && (
              <div className={`${baseClassName}__status`}>
                {statusComponent}
              </div>
            )}
            <div className={`${baseClassName}__actions`}>
              {footerComponent}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
